export const ScRuleRegData = {
	title: "RULES AND REGULATIONS FOR Scholarship SCHEME – 9",
	rules: [
		"If there are changes in Communication Details or Bank Details then beneficiaries have to inform SVGA accordingly.",
		"The decision of SVGA regarding acceptance or rejection of the application shall be final & binding on the applicant. SVGA is not bound to reveal reasons for acceptance/rejection of the application.",
		"SVGA has the right to make changes in rules and regulations. If there is a change or addition in rules and regulations then SVGA will inform the applicant via email/phone, etc.",
		"Fields marked with asterisk (*) sign are mandatory.",
		"Applicant shall preserve the Copy of the Application.",
		"I agree to abide by the above rules & regulations of Scholarship Year 2026-27.",
	],
};
